module.exports = __webpack_public_path__ + "img/_xy_.050bbcf1.svg";